/**
 * Curated city list for travel mode v1. AU-first per the audit's
 * Melbourne→Sydney rollout. International cities follow free-text +
 * geocode in a follow-up.
 */
export interface City {
  key: string;
  label: string;
  lat: number;
  lng: number;
}

export const CITIES: City[] = [
  { key: 'melbourne', label: 'Melbourne', lat: -37.8136, lng: 144.9631 },
  { key: 'sydney',    label: 'Sydney',    lat: -33.8688, lng: 151.2093 },
  { key: 'brisbane',  label: 'Brisbane',  lat: -27.4698, lng: 153.0251 },
  { key: 'perth',     label: 'Perth',     lat: -31.9523, lng: 115.8613 },
  { key: 'adelaide',  label: 'Adelaide',  lat: -34.9285, lng: 138.6007 },
];

export const findCity = (key: string | null | undefined): City | null =>
  key ? CITIES.find((c) => c.key === key) ?? null : null;
